import heroImage from '../assets/images/Coding-rafiki.svg';

export default function ContactSection() {

    //email address
    const myEmail = 'mosesquayson1997@gmail.com';
    //telephone
    const myPhone = '(+233) 55 367 2002';
    //linked in
    const linkedInUrl = 'https://www.linkedin.com/in/moquayson/';
    //twitter
    const twitterUrl = 'https://twitter.com/moquayson';
    //github
    const gitHubUrl = 'https://github.com/MoQuayson';



    return(
        <section id="contact" className="section">
            <div className="container">
                <div className="row flex-lg-row-reverse  g-2">
                    <div className="row flex-lg-row-reverse align-items-center g-5">
                        <div className="col-10 col-sm-8 col-lg-6">
                            <img src={heroImage} className="d-block mx-lg-auto img-fluid"  width="500" height="500"  alt="hero_image"/>
                        </div>

                        <div className="col-lg-6">
                            <div className="contact-content">
                                <h2 className='mb-2 fw-bold mb-5'>Have a project in mind?</h2>
                                <p className='mb-5'>Feel free to get in touch with me as I am always open
                                    to discussing new projects or help with improving already existing ones.
                                </p>

                                <div className="vstack gap-3">
                                    <div className="email">
                                        <div className='_label'>Email Address</div>
                                        <a href={`mailto: ${myEmail}`} target={'_blank'} rel='noreferrer'>{myEmail}</a>
                                    </div>
                                    
                                    <div className="telephone">
                                        <div className='_label'>Telephone No.</div>
                                        <a href={`tel:to ${myPhone}`} target={'_blank'} rel='noreferrer'>{myPhone}</a>
                                    </div>

                                    <div className="socials">
                                        <div className='_label'>Connect with me</div>

                                        <a href={twitterUrl} className='btn btn-primary' target={'_blank'} rel='noreferrer'>
                                            <i className='bi bi-twitter'></i>
                                        </a>

                                        <a href={linkedInUrl} className='btn btn-primary' target={'_blank'} rel='noreferrer'>
                                            <i className='bi bi-linkedin'></i>
                                        </a>

                                        <a href={gitHubUrl} className='btn btn-secondary' target={'_blank'} rel='noreferrer'>
                                            <i className='bi bi-github'></i>
                                        </a>   

                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </section>
    )
};
